import KunLoading81 from './src/index'

KunLoading81.install = function (Vue) {
	Vue.component(KunLoading81.name, KunLoading81);
}

export default KunLoading81;
